import { RateTag } from 'components/Rate/RateTag';
import Text from 'components/Text';
import { observer } from 'mobx-react-lite';
import useStores from 'stores/helpers/useStores';
import styled, { useTheme } from 'styled-components';
import { IPlayer } from 'types/Player';

const PlayerScore = styled.span`
  font-weight: 300;
`;

const StyledText = styled(Text)`
  display: flex;
  row-gap: 2px;
  column-gap: 8px;
  flex-wrap: wrap;
  align-items: center;
`;

interface Props {
  player: IPlayer;
  isCurrentPlayer: boolean;
}

export const PlayerName: React.FC<Props> = observer(
  ({ player, isCurrentPlayer }) => {
    const theme = useTheme();
    const { playerStore, matchStore } = useStores();

    const playerScore = playerStore.players.find(
      (p) => p.id === player.id
    )?.score;

    return (
      <StyledText
        my={12}
        key={player.id}
        variant="headline2"
        textTransform="uppercase"
        color={theme.palette.dark[800]}
        weight={isCurrentPlayer ? 600 : 400}
      >
        {player.firstName} {player.lastName}
        {matchStore.showRatings && (
          <>
            {' '}
            <PlayerScore>({playerScore ?? (player.score || 0)})</PlayerScore>
            {!isCurrentPlayer && <RateTag player={player} />}
          </>
        )}
      </StyledText>
    );
  }
);
